import {Inject, Injectable} from '@angular/core';
import {SupportedLanguageCode} from '@emma-labs/shared/typescript';
import {SupportedLanguage} from './supported-language';

export const ENGLISH_TRANSLATIONS = 'ENGLISH_TRANSLATIONS';
export const FRENCH_TRANSLATIONS = 'FRENCH_TRANSLATIONS';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  constructor(
    @Inject(ENGLISH_TRANSLATIONS) public englishTranslations: Map<string, string>,
    @Inject(FRENCH_TRANSLATIONS) public frenchTranslations: Map<string, string>,
  ) {}

  getTranslation(key: string): string | undefined {
    return this.getTranslationByLanguage(key, this.getCurrentLanguage());
  }

  getTranslationByLanguage(key: string, language: SupportedLanguage): string | undefined {
    switch (language) {
      case SupportedLanguage.FR:
        return this.getFrenchTranslation(key);
      case SupportedLanguage.EN:
        return this.getEnglishTranslation(key);
      default:
        return this.getEnglishTranslation(key);
    }
  }

  currentLanguageIsFr(): boolean {
    return this.getBrowserLanguage() === SupportedLanguage.FR;
  }

  getCurrentLanguage(): SupportedLanguage {
    return this.getBrowserLanguage();
  }

  getCurrentLanguageCode(): SupportedLanguageCode {
    return this.getCurrentLanguage() === SupportedLanguage.FR ? 'fr' : 'en';
  }

  private getBrowserLanguage(): SupportedLanguage {
    const splitUrl = document.URL.split('/');

    if (!splitUrl.includes('en') && !splitUrl.includes('fr')) {
      return this.toSupportedLanguage(navigator.language.slice(0, 2));
    } else {
      return splitUrl.includes('en') ? SupportedLanguage.EN : SupportedLanguage.FR;
    }
  }

  private getFrenchTranslation(key: string): string | undefined {
    if (this.frenchTranslations.has(key)) {
      return this.frenchTranslations.get(key);
    } else {
      return '';
    }
  }

  private getEnglishTranslation(key: string): string | undefined {
    if (this.englishTranslations.has(key)) {
      return this.englishTranslations.get(key);
    } else {
      return '';
    }
  }

  private toSupportedLanguage(language: string): SupportedLanguage {
    if (language == 'en') {
      return SupportedLanguage.EN;
    } else {
      return SupportedLanguage.FR;
    }
  }
}
